import './login-modal.sass';

import React from 'react';

import Form from 'components/login/form/Form';

export default function LoginModal() {
  return (
    <div className='login-modal' role='dialog' aria-modal='true' aria-labelledby='login-modal-title'>
      <div className='login-modal__backdrop' />
      <div className='login-modal__dialog'>
        <Form />
      </div>
    </div>
  );
}
